// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"components/swiper":"b275ea3f","components/fuse":"46ba60ca","components/vue":"b8a03a39"}[chunkId] + ".js";
};